import React from "react"
import { graphql } from "gatsby"

import Hero from "../components/home/hero"
import ExploreCourses from "../components/home/explore-courses"
import LearningPaths from "../components/home/learning-paths"
import Testimonials from "../components/home/testimonials"
import ExploreArticles from "../components/home/explore-articles"
import Newsletters from "../components/home/newsletters"
import Community from "../components/home/community"
import DeveloperInfo from "../components/home/developer-info"
import Jobs from "../components/home/jobs"
import TrialSection from "../components/home/trial-section"
import SEO from "../components/seo.latest"

const HomePage = ({
  data: {
    coursesCovers,
    learningPathsCovers,
    topics: { nodes: topics },
  },
}) => {
  const coversMap = [
    ...coursesCovers.nodes,
    ...learningPathsCovers.nodes,
  ].reduce(
    (acc, c) => ({ ...acc, [c.slug.current]: c.cover.asset.gatsbyImageData }),
    {}
  )

  return (
    <>
      <Hero topics={topics} />
      <ExploreCourses covers={coversMap} topics={topics} />
      <DeveloperInfo />
      <Testimonials />
      <LearningPaths covers={coversMap} />
      <Jobs />
      <ExploreArticles />
      <Newsletters />
      <Community />
      <TrialSection />
    </>
  )
}

export function Head({ data }) {
  const { site } = data
  return (
    <SEO
      title={site.siteMetadata.title}
      description={site.siteMetadata.description}
      image={site.siteMetadata.imageUrl}
      schema={JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Organization",
        "@id": `${process.env.GATSBY_BASE_URL}/#Organization`,
        name: "SitePoint",
        description: site.siteMetadata.description,
        url: `${process.env.GATSBY_BASE_URL}/`,
        actionableFeedbackPolicy: `${process.env.GATSBY_BASE_URL}/contact-us/`,
        logo: `${process.env.GATSBY_BASE_URL}/static-images/sitepoint-logo.png`,
        contactPoint: {
          "@type": "ContactPoint",
          contactType: "Support",
          email: "support@sitepoint.com",
          availableLanguage: "English",
        },
        sameAs: [
          "https://www.facebook.com/sitepoint",
          "https://twitter.com/sitepointdotcom",
        ],
      })}
    >
      <meta name="seznam-wmt" content="5zAqdqc7d6XBYxoDyjBsJNkcAohm9QQU" />
      <meta name="yandex-verification" content="afa5fceebc44c49d" />
    </SEO>
  )
}

export default HomePage

export const query = graphql`
  query ($coursesSlugs: [String], $learningPathsSlugs: [String]) {
    coursesCovers: allSanityCover(
      filter: { slug: { current: { in: $coursesSlugs } } }
    ) {
      nodes {
        cover {
          asset {
            gatsbyImageData(
              width: 282
              height: 180
              layout: CONSTRAINED
              placeholder: BLURRED
            )
          }
        }
        slug {
          current
        }
      }
    }
    learningPathsCovers: allSanityCover(
      filter: { slug: { current: { in: $learningPathsSlugs } } }
    ) {
      nodes {
        cover {
          asset {
            gatsbyImageData(
              width: 282
              height: 163
              layout: CONSTRAINED
              placeholder: BLURRED
            )
          }
        }
        slug {
          current
        }
      }
    }
    site {
      siteMetadata {
        title
        description
      }
    }
    topics: allSpPremiumTopic {
      nodes {
        id
        name
        slug
        contentCount
      }
    }
  }
`
